import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import * as icons from '@boxine/tonies-ui/icons';
import { Image } from '../image/image';
import Icon from '../Icon';
import { variables } from '../themes/variables';
export const AvatarWrapper = styled.div `
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  background: #fff;
  border: 0.125rem solid ${variables.DirtyWhite};

  ${props => {
    if (props.type === 'round') {
        return css `
        border-radius: 3px;
      `;
    }
    if (props.type === 'square') {
        return css `
        border-radius: 0;
      `;
    }
    if (props.type === 'circle') {
        return css `
        border-radius: ${props.width}px;
      `;
    }
}}
  .edit-icon-wrapper {
    display: none;
  }

  ${props => {
    if (props.interactive === 'hover') {
        return css `
        &:hover {
          background-color: black;
          cursor: pointer;
          > div > img {
            opacity: 0.6;
            z-index: 1;
          }
          .edit-icon-wrapper {
            position: absolute;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .icon {
              transform: scale(0.35);
              z-index: 2;
              svg {
                opacity: 1 !important;
              }
            }
          }
        }
      `;
    }
    if (props.interactive === 'always') {
        return css `
        background-color: black;
        cursor: pointer;
        > div > img {
          opacity: 0.6;
          z-index: 1;
        }
        .edit-icon-wrapper {
          position: absolute;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .icon {
            transform: scale(0.35);
            z-index: 2;
            svg {
              opacity: 1 !important;
            }
          }
        }
      `;
    }
}}
`;
/**
 * @deprecated since version 35.10.0, please use AvatarV2 instead
 */
class Avatar extends React.PureComponent {
    render() {
        const extraClass = this.props.className;
        return (React.createElement(AvatarWrapper, { width: this.props.width, height: this.props.height, type: this.props.type, className: `avatar-wrapper ${extraClass}`, interactive: this.props.interactive, onClick: this.props.interactive !== 'none'
                ? this.props.interactiveClick
                : () => undefined },
            this.props.interactive === 'hover' ||
                this.props.interactive === 'always' ? (React.createElement("span", { className: "edit-icon-wrapper" },
                React.createElement(Icon, { type: icons.edit, fill: "#fff", width: this.props.width, height: this.props.height, title: this.props.editTitle }))) : null,
            React.createElement(Image, Object.assign({}, this.props))));
    }
}
Avatar.propTypes = Object.assign(Object.assign({}, Image.propTypes), { height: PropTypes.number.isRequired, width: PropTypes.number.isRequired, src: PropTypes.string.isRequired, type: PropTypes.oneOf(['square', 'round', 'circle']), className: PropTypes.string, interactive: PropTypes.oneOf(['hover', 'always', 'none']), interactiveClick: PropTypes.func, editTitle: PropTypes.string });
Avatar.defaultProps = Object.assign(Object.assign({}, Image.defaultProps), { type: 'square', editTitle: 'Edit' });
export { Avatar };
